import { Link } from 'react-router-dom';

/**
 * BlogLink — a thin, single-row link card pointing to a blog post.
 *
 * Props:
 *   to       — internal path, e.g. "/blog/max-pain/what-is-max-pain"
 *   children — label text
 *   dark     — (optional) if true, uses slightly darker bg (for use inside coloured cards)
 *   tooltip  — (optional) short description shown in a hover tooltip
 */
export default function BlogLink({ to, children, dark = false, tooltip }) {
  return (
    <div className="relative group">
      {tooltip && (
        <div className="pointer-events-none absolute bottom-full left-0 mb-2 z-20 w-64
                        bg-neutral-900 dark:bg-neutral-800 text-white text-[11px] leading-snug
                        rounded-clay-sm px-3 py-2 shadow-lg
                        opacity-0 group-hover:opacity-100 transition-opacity duration-150">
          {tooltip}
          {/* Arrow */}
          <div className="absolute top-full left-4 -mt-px border-4 border-transparent border-t-neutral-900 dark:border-t-neutral-800" />
        </div>
      )}
    <Link
      to={to}
      className={`flex items-center gap-2 px-3 py-2 rounded-clay border border-neutral-200 dark:border-white/8 text-xs text-neutral-500 dark:text-neutral-400 hover:text-primary-600 dark:hover:text-primary-400 hover:border-primary-300 dark:hover:border-primary-600 transition-colors ${
        dark
          ? 'bg-neutral-50 dark:bg-white/[0.03]'
          : 'bg-surface'
      }`}
    >
      {/* Book icon */}
      <svg
        className="w-3.5 h-3.5 flex-shrink-0"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
        />
      </svg>

      <span className="flex-1 truncate">{children}</span>

      {/* Arrow icon */}
      <svg
        className="w-3 h-3 flex-shrink-0"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        viewBox="0 0 24 24"
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
      </svg>
    </Link>
    </div>
  );
}
